import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-validated-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './validated-checkbox.component.html',
  styleUrl: './validated-checkbox.component.scss',
})
export class ValidatedCheckboxComponent {
  label = input.required<string>();
  inputFormControlName = input<string>();
  inputFormControl = input<FormControl | null>(null);
  id = input<string>();
  validationTrainslations = input<{ [key: string]: string }>();
  leaveSpaceForValidation = input<boolean>(false);

  dense = input<boolean>(false);

  disabled = input<boolean>(false);

  // Optional model-style binding when no FormControl is provided
  value = input<boolean | null>(null);
  valueChange = output<boolean>();

  private static nextId = 0;
  private readonly autoId = `validated-checkbox-${ValidatedCheckboxComponent.nextId++}`;

  private get control(): FormControl | null {
    return this.inputFormControl();
  }

  get controlId(): string {
    return this.inputFormControlName() || this.id() || this.autoId;
  }

  isChecked(): boolean {
    const ctrl = this.control;
    if (ctrl) {
      return !!ctrl.value;
    }
    const v = this.value();
    return !!v;
  }

  onToggle(checked: boolean): void {
    if (this.disabled()) {
      return;
    }
    const ctrl = this.control;
    if (ctrl) {
      ctrl.setValue(checked);
      ctrl.markAsTouched();
    } else {
      this.valueChange.emit(checked);
    }
  }

  hasRequiredValidator(): string | boolean {
    const ctrl = this.control;
    return ctrl ? ctrl.hasValidator(Validators.requiredTrue) : false;
  }

  errorKeys(): string[] {
    const control = this.control;
    return control?.errors ? Object.keys(control.errors) : [];
  }

  getErrorMessage(errorKey: string): string {
    return this.validationTrainslations()?.[errorKey] ?? errorKey;
  }
}
